// The #fragment of every URL in any string of a value: on /hosted it can hold the link token (#t=).
// One linear pass: each run of URL characters is cut at its first # after a /.
const URL_RUN = /[^\s"'<>]+/g

const cutFragment = (run: string): string => {
  const slash = run.indexOf('/')
  const hash = slash === -1 ? -1 : run.indexOf('#', slash)
  return hash === -1 ? run : run.slice(0, hash)
}

const MAX_DEPTH = 16

const isPlainObject = (value: object): boolean => {
  const proto = Object.getPrototypeOf(value)
  return proto === Object.prototype || proto === null
}

export const stripUrlFragments = <T>(value: T, depth = 0): T => {
  if (typeof value === 'string') {
    return value.replace(URL_RUN, cutFragment) as T
  }
  // Class instances (Sentry keeps scopes in sdkProcessingMetadata) are left whole.
  if (!value || typeof value !== 'object' || (!Array.isArray(value) && !isPlainObject(value))) {
    return value
  }
  // Fails closed: a subtree past the bound is dropped rather than sent unscrubbed.
  if (depth > MAX_DEPTH) {
    return '[Filtered]' as T
  }
  if (Array.isArray(value)) {
    return value.map((item) => stripUrlFragments(item, depth + 1)) as T
  }
  return Object.fromEntries(
    Object.entries(value).map(([key, nested]) => [key, stripUrlFragments(nested, depth + 1)]),
  ) as T
}
